import { atom, useRecoilState } from "recoil";

import RestApiCall from "interceptor/aeh";
import { API_FETCH_STATUS } from "constants/common";
import Environment from "services/environment";

const env = Environment.getEnv();

const fetchNotificationsAPI = ({ payload }) => {
  const apiPayload = {
    method: "POST",
    url: "user-canp-notification/fetch",
    baseURL: env.notificationBaseUrl,
    data: payload,
    config: { ivUser: env.ivUser },
  };
  return RestApiCall.api(apiPayload);
};

const markReadAPI = ({ params }) => {
  const apiPayload = {
    method: "POST",
    url: "user-canp-notification/mark-read",
    baseURL: env.notificationBaseUrl,
    params,
    config: { ivUser: env.ivUser },
  };
  return RestApiCall.api(apiPayload);
};

const fetchBannersAPI = ({ params }) => {
  const apiPayload = {
    method: "GET",
    url: "user-canp-notification/alerts",
    baseURL: env.notificationBaseUrl,
    params,
    config: { ivUser: env.ivUser },
  };
  return RestApiCall.api(apiPayload);
};

const { SUCCESS, LOADING, ERROR } = API_FETCH_STATUS;

const NOTIFICATIONS_INITIAL_STATE = {
  state: LOADING,
  contents: {
    data: {
      notificationList: [],
      unreadCount: 0,
      totalUnReadCount: 0,
    },
    totalCount: 0,
    currentPageRecords: 0,
    pageNumber: 0,
    pageSize: 0,
  },
};

const BANNERS_INITIAL_STATE = {
  state: LOADING,
  contents: {
    bannerList: [],
  },
};

const notificationsAtom = atom({
  key: "notifications",
  default: { ...NOTIFICATIONS_INITIAL_STATE },
});

const bannersAtom = atom({
  key: "banners",
  default: { ...BANNERS_INITIAL_STATE },
});

const useNotifications = () => {
  const [notificationsState, setNotificationsState] = useRecoilState(notificationsAtom);
  const [bannersState, setBannersState] = useRecoilState(bannersAtom);

  const fetchNotifications = ({ partyId, pagination, searchQueries, lob }) => {
    const payload = {
      request: {
        partyId,
        lob,
      },
      pagination,
      searchQueries,
    };
    setNotificationsState({ ...notificationsState, state: LOADING });
    return new Promise((resolve, reject) => {
      fetchNotificationsAPI({ payload })
        .then((res) => {
          if (res.data && !res.data.code) {
            setNotificationsState({ contents: { ...res.data }, state: SUCCESS });
            resolve(res.data);
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          setNotificationsState({ ...NOTIFICATIONS_INITIAL_STATE, state: ERROR });
          reject(err);
        });
    });
  };

  const markRead = ({ notificationId, partyId }) => {
    const params = {
      notificationId,
    };
    return new Promise((resolve, reject) => {
      markReadAPI({ params })
        .then((res) => {
          fetchNotifications({ partyId });
          fetchBanners();
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const fetchBanners = ({ lob } = {}) => {
    const params = {
      lob,
    };
    setBannersState({ ...bannersState, state: LOADING });
    return new Promise((resolve, reject) => {
      fetchBannersAPI({ params })
        .then((res) => {
          if (res.data && !res.data.code) {
            setBannersState({ contents: { bannerList: res.data }, state: SUCCESS });
            resolve(res.data);
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          setBannersState({ ...BANNERS_INITIAL_STATE, state: ERROR });
          reject(err);
        });
    });
  };

  return {
    notifications: notificationsState,
    setNotificationsState,
    banners: bannersState,
    setBannersState,
    fetchBanners,
    fetchNotifications,
    markRead,
  };
};

export default useNotifications;
